// extracted by mini-css-extract-plugin
export default {"textarea_container":"styles_textarea_container__X1z5T","max_lenght_label":"styles_max_lenght_label__ICqxN"};